import React from 'react';

const LoadingContext = React.createContext();

export { LoadingContext as default };
